import { object, string, array } from 'yup';

export const formApiErrorTypeStrings = [
  'MAX_NUMBER_OF_SUBMITTED_VALUES_EXCEEDED',
  'INVALID_EMAIL',
  'BLOCKED_EMAIL',
  'REQUIRED_FIELD',
  'INVALID_NUMBER',
  'INPUT_TOO_LARGE',
  'FIELD_NOT_IN_FORM_DEFINITION',
  'NUMBER_OUT_OF_RANGE',
  'VALUE_NOT_IN_FIELD_DEFINITION',
  'INVALID_METADATA',
  'INVALID_GOTOWEBINAR_WEBINAR_KEY',
  'INVALID_HUTK',
  'INVALID_IP_ADDRESS',
  'INVALID_PAGE_URI',
  'INVALID_LEGAL_OPTION_FORMAT',
  'MISSING_PROCESSING_CONSENT',
  'MISSING_PROCESSING_CONSENT_TEXT',
  'MISSING_COMMUNICATION_CONSENT_TEXT',
  'MISSING_LEGITIMATE_INTEREST_TEXT',
  'DUPLICATE_SUBSCRIPTION_TYPE_ID',
  'FORM_HAS_RECAPTCHA_ENABLED',
] as const;

export const formResponseFailure = object({
  status: string().required(),
  message: string(),
  correlationId: string().required(),
  errors: array().of(object({
    message: string(),
    errorType: string().oneOf([...formApiErrorTypeStrings]),
  })),
});

export const formResponseSuccess = object().shape({
  inlineMessage: string().required(),
});
